export const alternateFactory = (isRegister, route) => {
  let text = ''
  if (isRegister) {
    text = 'Já é cadastrado? Faça o login.'
  } else {
    text = 'Ainda não tem cadastro? Registre-se agora.'
  }
  return {text, route}
}
